import { ManagePermissionsSettingsTranslation } from 'locales/de/pages/managePermissionsSettings';

const en: ManagePermissionsSettingsTranslation = {
  title: 'Permissions Settings',
  permissionScheme: 'Permission scheme',
  roles: 'Roles',
  role: 'Role',
  roleName: 'Rolename',
  entitlements: 'Entitlements',
  entitlement: 'Entitlement',
  permission: 'Permission',
  status: 'Status',
  icon: 'Icon',
  actions: 'Actions',
  recipients: 'Recipient',
  authorRole: 'Author role',
  deactivateRole: 'Deactivate role',
  activateRole: 'Activate role',
  cancel: 'Cancel',
  deactivationModal: {
    title: 'Really deactivate?',
    message: 'Do you want to deactivate this role?'
  },
  activationModal: {
    title: 'Really activate?',
    message: 'Do you want to activate this role?'
  },
  successfullyUpdated: 'Successfully updated role!',
  errorLoading: 'Could not load permission scheme.',
  noGroupRoles: 'This title is not included in any role',
  noItemFound: 'No item was found.',
  editRole: 'Edit role',
  deleteRole: 'Delete role',
  createRole: 'Create role',
  roleCreation: 'Role creation',
  roleEditing: 'Role editing',
  editPermission: 'Edit permission',
  deletePermission: 'Delete permission',
  createPermission: 'Create Permission',
  permissionCreation: 'Permission creation',
  permissionEditing: 'Permission editing',
  active: 'Aktiv',
  alertsRole: {
    saveFailed: 'The role could not be saved.',
    saveSuccess: 'The role was successfully saved.',
    deleteFailed: 'The role could not be deleted. Cause: {{cause}}',
    deleteSuccess: 'The role was successfully deleted.'
  },
  deleteModalRole: {
    title: 'Really delete?',
    message: 'Do you want to delete this role?'
  },
  alertsPermission: {
    saveFailed: 'The permission could not be saved.',
    saveSuccess: 'The permission was successfully saved.',
    deleteFailed: 'The permission could not be deleted. Cause: {{cause}}',
    deleteSuccess: 'The permission was successfully deleted.'
  },
  deleteModalPermission: {
    title: 'Really delete?',
    message: 'Do you want to delete this permission?'
  },
  alertsEntitlement: {
    deleteFailed: 'The entitlement could not be deleted.',
    deleteSuccess: 'The entitlement was successfully deleted.'
  },
  deleteModalEntitlment: {
    title: 'Really delete?',
    message:
      'Do you want to delete this entitlement? If a user owns the entitlement and logs in, it will be created again automatically!'
  }
};

export default en;
